var installedModules = {};
var moduleToHandlerMapping = {
	3400: {
		getter: function() { return __webpack_require__.e(668).then(function() { return function() { return __webpack_require__(5668); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	1536: {
		getter: function() { return __webpack_require__.e(356).then(function() { return function() { return __webpack_require__(2356); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	2568: {
		getter: function() { return __webpack_require__.e(140).then(function() { return function() { return __webpack_require__(9520); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	2776: {
		getter: function() { return __webpack_require__.e(528).then(function() { return function() { return __webpack_require__(3148); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	3560: {
		getter: function() { return __webpack_require__.e(868).then(function() { return function() { return __webpack_require__(2248); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	3648: {
		getter: function() { return __webpack_require__.e(261).then(function() { return function() { return __webpack_require__(4023); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	4504: {
		getter: function() { return __webpack_require__.e(172).then(function() { return function() { return __webpack_require__(6552); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	7289: {
		getter: function() { return __webpack_require__.e(460).then(function() { return function() { return __webpack_require__(840); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	7620: {
		getter: function() { return __webpack_require__.e(12).then(function() { return function() { return __webpack_require__(3392); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	8060: {
		getter: function() { return __webpack_require__.e(332).then(function() { return function() { return __webpack_require__(7712); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	9920: {
		getter: function() { return __webpack_require__.e(620).then(function() { return function() { return __webpack_require__(7000); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17 || ^18",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	5616: {
		getter: function() { return __webpack_require__.e(620).then(function() { return function() { return __webpack_require__(7000); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	9256: {
		getter: function() { return __webpack_require__.e(404).then(function() { return function() { return __webpack_require__(4023); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.5.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"23": [
		1536,
		3400
	],
	"32": [
		1536
	],
	"140": [
		1536
	],
	"148": [
		3400
	],
	"248": [
		3400
	],
	"261": [
		1536
	],
	"332": [
		1536
	],
	"356": [
		3400
	],
	"392": [
		3400
	],
	"468": [
		1536,
		3400
	],
	"520": [
		1536,
		3400
	],
	"552": [
		3400
	],
	"624": [
		1536,
		3400,
		5616,
		9256
	],
	"684": [
		2568,
		2776,
		3400,
		3560,
		3648,
		4504,
		7289,
		7620,
		8060,
		9920
	],
	"712": [
		1536,
		3400
	],
	"728": [
		1536,
		3400,
		5616,
		9256
	],
	"840": [
		3400
	],
	"946": [
		1536,
		3400,
		5616,
		9256
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({chunkMapping, installedModules, chunkId, moduleToHandlerMapping, promises, webpackRequire:__webpack_require__});
}